// extracted by mini-css-extract-plugin
export default {"galeryContainer":"ActionPicture_galeryContainer__rs-J-","block":"ActionPicture_block__zWvs3","selected":"ActionPicture_selected__SkUzI"};